import React from "react";
import "./Footer.css";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="social-icons">
          <a href="https://codepen.io/grauconejo13" target="_blank" rel="noreferrer">
            <i className="fab fa-codepen"></i>
          </a>
          <a href="https://github.com/grauconejo13" target="_blank" rel="noreferrer">
            <i className="fab fa-github"></i>
          </a>
          <a href="https://www.linkedin.com/in/vanessa-victorino-23b588124" target="_blank" rel="noreferrer">
            <i className="fab fa-linkedin"></i>
          </a>
          <a href="https://dev.to/grauconejo13/" target="_blank" rel="noreferrer">
            <i className="fab fa-dev"></i>
          </a>
          <a href="https://discord.com/users/grauconejo13" target="_blank" rel="noreferrer">
            <i className="fab fa-discord"></i>
          </a>
          <a href="https://x.com/grauconejo13" target="_blank" rel="noreferrer">
            <i className="fab fa-x-twitter"></i>
          </a>
          <a href="https://devpost.com/vanessaf-victorino" target="_blank" rel="noreferrer">
            <i className="fas fa-link"></i>
          </a>
        </div>

        <small className="footer-copy">
          &copy; {year} Vanessa Victorino. All rights reserved.
        </small>
      </div>
    </footer>
  );
}

export default Footer;
